<div class="fullcontainer">
  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header' style='color: #006498'>Stock Movement History</h2>

    <div>
      <button class='btn btn-secondary' routerLink='/warehousing/stock-levels'><i class="fas fa-layer-group"></i> Stock Levels</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/warehousing/dashboard'><i class="fas fa-tachometer-alt"></i> Dashboard</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/warehousing/reports'><i class="fas fa-chart-line"></i> Reports</button>&nbsp;
    </div>
  </div>
  <br />



  <div class="form-row">
    <div class="form-group col-md-3">
      <label>Warehouse</label>
      <select class='form-control' (change)='this.onWarehouseChanged($event.target.value)'>
        <option value='-1'>All warehouses</option>
        @for (item of this.warehouses; track item) {
          <option [value]='item.id' [selected]='this.selectedWarehouseId === item.id'>{{ item.name }}</option>
        }
      </select>
    </div>
    <div class="form-group col-md-3">
      <label>Location</label>
      <select class='form-control' [disabled]='this.selectedWarehouseId === -1' (change)='this.onLocationChanged($event.target.value)'>
        <option value='-1'>All locations</option>
        @for (item of this.locations; track item) {
          <option [value]='item.id' [selected]='this.selectedLocationId === item.id'>{{ item.aisle }} / {{ item.shelf }}</option>
        }
      </select>
    </div>
    <div class="form-group col-md-3">
      <label>Product</label>
      <select class='form-control' (change)='this.onProductChanged($event.target.value)'>
        <option value='-1'>All products</option>
        @for (item of this.products; track item) {
          <option [value]='item.id' [selected]='this.selectedProductId === item.id'>{{ item.name }}</option>
        }
      </select>
    </div>
    <div class="form-group col-md-3">
      <label>Movement Type</label>
      <select class='form-control' (change)='this.onMovementTypeChanged($event.target.value)'>
        <option value=''>All types</option>
        @for (item of this.movementTypes; track item) {
          <option [value]='item.value' [selected]='this.selectedMovementType === item.value'>{{ item.label }}</option>
        }
      </select>
    </div>
  </div>
  <br />

  <app-grid
    entity='product-stock-movement'
    [filters]='this.filters'
    [columns]='this.columns'
    [relationships]='this.relationships'
    [searchFilters]='this.searchFilters'
    [searchFields]='this.searchFields'
    sortColumn='id'
    sortDirection='desc'
  ></app-grid>
</div>
